const cmtId = 's26';
let loaded = false;
let gaId = [];

export default class Analytics4 {

  constructor(){

  }

  load() {
      let GaMeasurementId = 'G-2P6H126V0E';
      switch (window.location.hostname) {
      case "abo.mannheimer-morgen.de":
      case "abo-suedhessen.mannheimer-morgen.de":
      GaMeasurementId = 'OPT-WZ3RPZL'
      break;
      case "abo.fnweb.de":
      GaMeasurementId = 'G-KRYCTJ5NBE'
      break;
      case "abo.schwetzinger-zeitung.de":
      GaMeasurementId = 'G-4T3V7JZWSL'
      break;
      case "abo.bergstraesser-anzeiger.de":
      GaMeasurementId = 'G-3TSHK3HXQZ'
      break;
      default:
      GaMeasurementId = 'G-2P6H126V0E';
      break;
      }
      this.loadDynamicLib('https://www.googletagmanager.com/gtag/js?id='+GaMeasurementId)
      .then(() => {

        window.dataLayer = window.dataLayer || [];
        function gtag(){dataLayer.push(arguments);}
        gtag('js', new Date());
        gtag('config', GaMeasurementId);
      }).catch();
      loaded = true;

  }

  getCmtId() {
    return cmtId;
  }

  destroy(){
    const cookieNames = ['_ga', '_gid', '_gat', '_AMP_TOKEN', '_gcl_au', '_gat_global']
    window.ga = {};
    gaId.forEach( (item) => {
      window['ga-disable-'+item] = true;
    });
    cookieNames.forEach( (cookieName) => {
      this.destroyCookie(cookieName);
    });
    loaded = false;
  }

  isLoaded() {
    return loaded;
  }

  destroyCookie(cookieName) {
      let domain = document.location.hostname.replace(/^[^.]+/g, "");
      let expires = "expires=Thu, 01 Jan 1970 00:00:00 GMT"
      document.cookie = cookieName + "='';" + expires + ";domain="+domain+";path=/;";
      return true;
  }

  async loadDynamicLib(url) {
      return new Promise((resolve, reject) => {
        const script = document.createElement('script');
        script.type = 'text/javascript';
        script.onload = resolve;
        script.onerror = reject;
        script.src = url;
        document.head.append(script);
      });
    }

}
